import angular from 'angular';

angular.module('cxInvoicing', ['commonServices', 'cxHttpServices']);
